import React from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { Icon, Link, BoxProps } from '@chakra-ui/react'
import {
  Definition,
  Section,
  SectionBody,
  SectionHeader,
} from '@apexinternal/ui-components'
import { USD_DISCLAIMER } from '../../constants'
import { AccountPosition, RoutesEnum } from '../../types'
import { NO_POSITIONS_TO_DISPLAY } from '../../constants/constants'
import { numberToCurrency } from '../../utils'
import { CurrencyEnum } from '../../utils/numberToCurrency'
import { isEmpty } from 'lodash'

export interface PositionsTableProps extends BoxProps {
  positions?: AccountPosition[]
  accountNumber: string
}

const PositionsTable = ({
  positions,
  accountNumber,
  ...rest
}: PositionsTableProps) => (
  <Section data-testid="positions-table" {...rest}>
    <SectionHeader
      tools={
        <Link
          href={`/${RoutesEnum.Accounts}/${accountNumber}/positions?skipSearch=true`}
          sx={{
            ':hover': {
              color: 'apex.white',
            },
            color: 'apex.white',
            fontWeight: 'regular',
          }}
        >
          Position Details <Icon as={FaArrowRight} color="apex.white" />
        </Link>
      }
    >
      Positions
    </SectionHeader>
    <SectionBody>
      {positions && !isEmpty(positions) ? (
        <>
          <Definition
            key="equities"
            term="Equities"
            definition={`${numberToCurrency(
              positions[0].totalValue,
              CurrencyEnum.usd
            )}`}
          />
          <Definition
            key="total-market-value"
            term="Total Market Value"
            definition={`${numberToCurrency(
              positions[1].totalValue,
              CurrencyEnum.usd
            )}`}
          />
          <Definition
            key="usd-disclaimer"
            term={USD_DISCLAIMER}
            definition=""
            borderBottom="none"
          />
        </>
      ) : (
        <Definition
          key="no-positions"
          term={NO_POSITIONS_TO_DISPLAY}
          definition=""
        />
      )}
    </SectionBody>
  </Section>
)

export default PositionsTable
